import request from '@/utils/request'

// 查询合并信息列表
export function fetchMergeList(params) {
  return request({
    url: '/upkeep/order/merge/page',
    method: 'get',
    params,
  })
}

// 新建订单合并
export function createMerge(data) {
  return request({
    url: '/upkeep/order-merge',
    method: 'post',
    data,
  })
}

// 确认合并
export function confirmMerge(ids) {
  return request({
    url: '/upkeep/order-merge/confirm',
    method: 'put',
    data: ids,
  })
}

// 取消合并
export function cancelMerge(ids) {
  return request({
    url: '/upkeep/order-merge/cancel',
    method: 'put',
    data: ids,
  })
}

// 导出合并信息
export function exportMerge(params) {
  return request({
    url: '/upkeep/order-merge/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}
